import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

type DateInput = Date | string | number | null | undefined

export function toDayjs(input: DateInput): dayjs.Dayjs | null {
    if (input == null) return null
    const d = dayjs(input)
    return d.isValid() ? d : null
}

export const parseToLocalDate = (isoString?: string) => {
    if (!isoString) return undefined
    const d = dayjs(isoString)
    return d.isValid() ? new Date(d.year(), d.month(), d.date()) : undefined
}

/* ---------- Date ---------- */
export function formatDateTime(
    input: DateInput,
    pattern = 'DD/MM/YYYY HH:mm',
): string {
    if (!input) return ''
    const d = dayjs(input)
    return d.isValid() ? d.format(pattern) : ''
}

export function formatStartDate(input: any): string {
    if (!input) return ''
    const d = dayjs(input)
    return d.isValid() ? d.startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : ''
}

export function formatEndDate(input: any): string {
    if (!input) return ''
    const d = dayjs(input)
    return d.isValid() ? d.endOf('day').millisecond(0).format('YYYY-MM-DDTHH:mm:ss.SSSZ') : ''
}

/* ---------- Number / Currency ---------- */

export function formatNumber(
    value: number | null | undefined,
    locale = 'vi-VN',
): string {
    if (value == null || Number.isNaN(value)) return ''
    return new Intl.NumberFormat(locale).format(value)
}

export function formatCurrency(
    value: number | null | undefined,
    currency = 'VND',
    locale = 'vi-VN',
): string {
    if (value == null || Number.isNaN(value)) return ''
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
    }).format(value)
}

/* ---------- String ---------- */

export function truncate(
    str: string | null | undefined,
    max: number,
): string {
    if (!str) return ''
    return str.length > max ? str.slice(0, max - 1) + '…' : str
}

export function capitalize(str: string | null | undefined): string {
    if (!str) return ''
    return str.charAt(0).toUpperCase() + str.slice(1)
}